import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hello" }
const _hoisted_2 = { style: {"width":"600px","margin":"20px auto","text-align":"left"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createTextVNode(" 🎁框架基于vue-cli生成，没有多余的第三方组件和库，只整合了 ")),
        _createVNode(_component_router_link, { to: "/demo/vuex" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("vuex")
          ])),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createTextVNode("， ")),
        _createVNode(_component_router_link, { to: "/demo/vue-router" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("vue-router")
          ])),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createTextVNode("， ")),
        _createVNode(_component_router_link, { to: "/demo/request" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("axios")
          ])),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createTextVNode("， 配置了eslint规范。 "))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, "⚡右下角提供了离线文档入口👩‍🔧，方便随时开发查阅，减少上网查询的时间", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, "🎨整理了日常开发中常用的demo代码，可以直接复制粘贴使用", -1)),
      _createElementVNode("p", null, [
        _cache[8] || (_cache[8] = _createTextVNode(" 🥉对vue3的新特性有更贴近于实战的文档和demo， ")),
        _createVNode(_component_router_link, { to: "/demo/setup" }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("欢迎指导")
          ])),
          _: 1
        })
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("p", { style: {"margin-top":"30px"} }, "👌ps:离线文档和demo所有相关内容，只在development环境会引入，其他环境不会被打包，可以放心存在项目中，不必删除", -1))
    ])
  ]))
}